import { useAlertEvents, useAcknowledgeAlert } from "@/hooks/use-alerts";
import { cn, getRiskBg } from "@/lib/utils";
import { Bell, Check } from "lucide-react";

export function AlertsPage() {
  const { data, isLoading } = useAlertEvents();
  const acknowledge = useAcknowledgeAlert();

  const events = data?.events || [];
  const unackCount = data?.unacknowledgedCount || 0;

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">Alerts</h1>
          <p className="text-sm text-slate-500 mt-1">{unackCount} unacknowledged</p>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200">
        {isLoading ? (
          <div className="px-6 py-16 text-center text-slate-400">Loading alerts...</div>
        ) : events.length === 0 ? (
          <div className="px-6 py-16 text-center">
            <Bell className="w-10 h-10 text-slate-300 mx-auto mb-3" />
            <p className="text-sm text-slate-500">No alerts yet</p>
            <p className="text-xs text-slate-400">Alerts will appear when monitored companies change</p>
          </div>
        ) : (
          <div className="divide-y divide-slate-100">
            {events.map((event: Record<string, unknown>) => (
              <div key={event.id as number} className={cn("px-6 py-4 flex items-center justify-between", event.acknowledged ? "opacity-60" : "")}>
                <div className="flex items-center gap-3">
                  <span className={cn("w-2 h-2 rounded-full", event.severity === "critical" ? "bg-red-500" : event.severity === "warning" ? "bg-amber-500" : "bg-blue-500")} />
                  <div>
                    <p className="text-sm font-medium text-slate-900">{event.title as string}</p>
                    <p className="text-xs text-slate-500">
                      {event.razao_social as string || event.cnpj as string} — {new Date(event.created_at as string).toLocaleDateString("pt-BR")}
                    </p>
                  </div>
                </div>
                {!event.acknowledged && (
                  <button
                    onClick={() => acknowledge.mutate(event.id as number)}
                    className="p-1.5 rounded-lg hover:bg-slate-100"
                    title="Acknowledge"
                  >
                    <Check className="w-4 h-4 text-slate-500" />
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
